@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

:host {
  --font-family: var(--font-family-secondary);
}

.reporting-period-wrapper {
  font-size: var(--body-size-medium);
  text-align: left;
  padding: 0 20px;
  margin: var(--spacer) 0;
  color: var(--body-text-arrows-400);
}
